export const DEFAULT_VALIDATION_DELAY = 800;
